import { useQuery } from "@apollo/client";
import { InstallSectionCard } from "../InstallSectionCard";
import { useCompanyPageStore } from "../../../../../../store/companyPageStore";
import {
  INTENSITY_MOMENTUM_QUERY,
  IntensityMomentumPayload,
} from "../../../../../../legacy/queries/Intensity";
import { IntensityTable } from "./IntensityTable";
import { GridPaginationModel } from "@mui/x-data-grid";
import { useState } from "react";
import Box from "@mui/material/Box";
import { COMPANY_SEARCH_CLIENT } from "../../../../../../utils/consts";
const helpText =
  "Intensity Momentum shows the most recent 90-days percentage change of signal (intensity). It is useful for getting a shorter ranged view of a product at a company based on changes to the intensity, It is particularly useful compared with Intensity Trend to show how adoption is changing. It will have a theoretical min/max of approx +/-90%.";

export const IntensityMomentum = () => {
  const company = useCompanyPageStore((state) => state.company);
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });
  const [persistedTotalCount, setPersistedTotalCount] = useState(0);

  const { data, loading } = useQuery<IntensityMomentumPayload>(
    INTENSITY_MOMENTUM_QUERY,
    {
      context: { clientName: COMPANY_SEARCH_CLIENT },
      variables: {
        hgId: company!.hgId,
        page: paginationModel.page,
        per: paginationModel.pageSize,
      },
      onCompleted: (queryData) => {
        if (queryData?.intensityMomentum?.count !== undefined) {
          setPersistedTotalCount(queryData.intensityMomentum.count);
        }
      },
    }
  );

  return (
    <InstallSectionCard
      title="Intensity Momentum"
      height={700}
      noTitleMargin
      filterKey="INTENSITY_MOMENTUM"
    >
      <Box marginTop={3}>
        <IntensityTable
          data={data?.intensityMomentum?.data || []}
          loading={loading}
          title="Intensity Momentum"
          helpText={helpText}
          highlightText="Intensity Momentum"
          count={persistedTotalCount}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </Box>
    </InstallSectionCard>
  );
};
